export const mutations = {

    adminMatchesSetCurrentMatch(state, data) {
        state.currentMatch = data
    },

    adminMatchesSetSectors(state, data) {
        state.sectors = data
    },

    resetState(state) {
        state.currentMatch = {};
        state.sectors = {};
    }

};
